export interface ShopProductPromotion {
  readonly imageUrl: string;
  readonly name: string;
  readonly url: string;
}

export const shopProductPromotions: readonly ShopProductPromotion[] = [
  {
    imageUrl: 'https://cdn.shopify.com/s/files/1/0715/9385/3111/files/unisex-34-sleeve-raglan-shirt-white-kelly-front-69a623bc56fde.jpg?v=1772495820',
    name: 'Phantom Dark Classic Raglan – Green Edition',
    url: 'https://shop.nitrogenx.co/products/phantom-dark-classic-raglan-green-edition'
  },
  {
    imageUrl: 'https://cdn.shopify.com/s/files/1/0715/9385/3111/files/enhanced-matte-paper-poster-_in_-12x18-front-6931d917a13a9.jpg?v=1764874532',
    name: 'Phantom Dark: “Order Within Infinity” – Limited Edition Print',
    url: 'https://shop.nitrogenx.co/products/phantom-dark-order-within-infinity-limited-edition-print'
  },
  {
    imageUrl: 'https://cdn.shopify.com/s/files/1/0715/9385/3111/files/kiss-cut-holographic-stickers-grey-5.5x5.5-front-692e8171b97d0.jpg?v=1764655484',
    name: 'Phantom Dark Glitch Sticker',
    url: 'https://shop.nitrogenx.co/products/phantom-dark-glitch-sticker'
  }
];
